import { Classes, InputGroup, TextArea } from "@blueprintjs/core";
import {
    DefaultSelectedOption,
    filterItemPredicate,
    renderSingleOption,
    SimpleSelect,
} from "modules/common/services/form/select";
import React from "react";
import styles from "./OrgTree.module.scss";

/** Поля карточек дерева — те же planr-контролы, что в формах приложения */

export interface Option {
    id: string;
    label: string;
}

interface SelectFieldProps {
    value: string;
    options: Option[];
    onChange(value: string): void;
    disabled?: boolean;
    /** подпись пустого значения */
    emptyLabel?: string;
    filterable?: boolean;
}

export const SelectField = ({ value, options, onChange, disabled, emptyLabel, filterable }: SelectFieldProps) => {
    const items = emptyLabel ? [{ id: "", label: emptyLabel }, ...options] : options;
    const active = items.find((o) => o.id === value) ?? null;

    return (
        <div className={Classes.INPUT_GROUP}>
            <SimpleSelect
                className={`full-width-select ${Classes.FILL}`}
                filterable={!!filterable}
                itemPredicate={filterItemPredicate}
                activeItem={active}
                items={items}
                itemRenderer={renderSingleOption}
                onItemSelect={(item) => onChange(item.id)}
                disabled={disabled}
                inputProps={{ placeholder: "Поиск" }}
            >
                <DefaultSelectedOption option={active} disabled={disabled} what={emptyLabel} />
            </SimpleSelect>
        </div>
    );
};

export const TextField = ({
    value,
    onChange,
    disabled,
    inputRef,
    placeholder,
}: {
    value: string;
    onChange(value: string): void;
    disabled?: boolean;
    inputRef?: React.Ref<HTMLInputElement>;
    placeholder?: string;
}) => (
    <InputGroup
        className="planr-default-input"
        value={value}
        disabled={disabled}
        inputRef={inputRef}
        placeholder={placeholder}
        maxLength={200}
        autoComplete="off"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
    />
);

export const AreaField = ({
    value,
    onChange,
    disabled,
}: {
    value: string;
    onChange(value: string): void;
    disabled?: boolean;
}) => (
    <div className={`${Classes.INPUT_GROUP} planr-default-input`}>
        <TextArea
            className={Classes.FILL}
            value={value}
            disabled={disabled}
            autoResize
            onChange={(e) => onChange(e.target.value)}
        />
    </div>
);

export const Field = ({ label, hint, children }: { label: string; hint?: string; children: React.ReactNode }) => (
    <div className={styles.field}>
        <span className={styles.fieldLabel}>{label}</span>
        {children}
        {hint && <span className={styles.hint}>{hint}</span>}
    </div>
);
